import lightningGif from "icons/lightning/lightning.gif"
import lightningImg from "icons/lightning/lightning.jpg"

export default {
  img: lightningImg,
  gif: lightningGif,
}
